import React from 'react'
import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { em, color } from '../../../utils/styles'

const AddButtonWrapper = styled.div`
  text-align: center;
  margin: 2em 0 0;
`
const Button = styled.button`
  background: transparent;
  border: 0;
  padding: ${em(3)} ${em(5)};
  border-radius: ${em(3)};
  font-weight: ${theme('fontWeights.bold')};
  vertical-align: middle;
  cursor: pointer;

  &:active,
  &:focus {
    background-color: ${color('base')};
    color: #fff;
  }

  svg {
    display: inline-block;
    width: ${em(22)};
    height: ${em(22)};
  }
`

export default function AddButton(props) {
  return (
    <AddButtonWrapper>
      <Button type='button' {...props} />
    </AddButtonWrapper>
  )
}
